import React, { useEffect, useRef, useState } from "react";
import medicine from "../../assets/Icons/med1.svg";
import medicine1 from "../../assets/Icons/med3.svg";
import medicine2 from "../../assets/Icons/med2.svg";
import medicine3 from "../../assets/Icons/medcine4.svg";
import Trust from "../../assets/Icons/Trust.svg";
import Thumbs from "../../assets/Icons/thumbs-up.svg";
import Secure from "../../assets/Icons/secure.svg";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import {
  AddtoCart,
  getCartDetails,
  updateCartState,
} from "../../Redux/actions/cartActions";
import { useDispatch, useSelector } from "react-redux";
import { FaMinus, FaPlus } from "react-icons/fa";
import LocationService from "../../Services/LocationService";
import {
  createCartOrderDtlItem,
  createCartOrderHdrItem,
  getCurrentTime,
} from "../../Shared/CartHelper";
import { useLocation } from "react-router-dom";
import { message, Modal } from "antd";
import Layout from "../../Layout";
import { convertUTCDate } from "../../utils/convertionFunc";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import PatientService from "../../Services/PatientService";

function MedicineDetails() {
  const location = useLocation();
  const medicineObj = location.state?.medicine;
  const defaultImages = [medicine, medicine1, medicine2, medicine3];

  const validApiImages = medicineObj?.imageUrlList;

  const images = validApiImages;

  const [selectedImage, setSelectedImage] = useState(images[0] || null);
  const [loader, setLoader] = useState(false);
  const [isMedicineThereInCart, setIsMedicineThereInCart] = useState(false);
  const [activeTab, setActiveTab] = useState("Description");
  const [address, setAddress] = useState(null);
  const [addressModButton, setAddressModButton] = useState(false);
  const [medCartData, setMedCartData] = useState([]);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    address1: "",
    address2: "",
    city: "",
    country: "",
    mobile: "",
    pinCode: "",
    state: "",
  });
  const [patientMembershipDet, setPatientMembershipDet] = useState(null);
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const { patientData } = useSelector((state) => state.auth);
  const { cartData } = useSelector((state) => state.cart);
  const { states, countries } = useSelector((state) => state.common);
  const CURRENCYCODE = process.env.REACT_APP_CURRENCYCODE || "";

  useEffect(() => {
    if (images.length > 0) {
      setSelectedImage(images[0]);
    } else {
      setSelectedImage(null);
    }
  }, [medicineObj]);

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      fetchPatientAddress();
      fetchCartDetails();
      fetchMembershipDetails();
    }
  }, [patientData]);

  useEffect(() => {
    if (!cartData) {
      if (isMedicineThereInCart) setIsMedicineThereInCart(false);
      return;
    }
    const { cartOrderHdr } = cartData;
    const medData = cartOrderHdr?.find((item) => item.orderType === "DRUG");
    if (medData) {
      const medItems = medData?.cartOrderDtl;
      if (medItems && medItems?.length !== 0) {
        const isMedThereInCart = medItems?.find(
          (item) => item.orderCode === medicineObj.code,
        );
        if (isMedThereInCart) {
          setMedCartData(isMedThereInCart);
          setIsMedicineThereInCart(true);
        }
      }
    }
  }, [cartData]);

  useEffect(() => {
    if (isAddressModalOpen && patientData) {
      setFormData({
        firstName: patientData?.firstName + patientData?.lastName,
        address1: patientData?.address1,
        address2: patientData?.address2,
        city: patientData?.city,
        country: patientData?.country,
        mobile: patientData?.mobile,
        pinCode: patientData?.pinCode,
        state: patientData?.state,
      });
    }
  }, [isAddressModalOpen]);

  // useEffect(() => {
  //     if (patientMembershipDet) {
  //         const currentPrice = medicineObj?.mrp || 0;
  //         const discountAmount = Math.floor(currentPrice * (patientMembershipDet?.discountPercentage / 100));
  //         setDiscountAmt(discountAmount);
  //         const finalDoctorFee = currentPrice - discountAmount;
  //         setDiscountedPrice(finalDoctorFee);
  //     }
  // }, [medicineObj?.mrp, patientMembershipDet]);

  const calculateDiscountedPrice = (medicine, patientMembershipDet) => {
    const currentPrice = Number(medicine?.mrp) || 0;
    if (!patientMembershipDet) return currentPrice.toFixed(2);
    const discountPercent =
      Number(patientMembershipDet?.discountPercentage) || 0;
    const discountAmount = Math.floor(currentPrice * (discountPercent / 100));
    const finalMedPrice = currentPrice - discountAmount;
    return finalMedPrice?.toFixed(2);
  };

  const calculateDiscountAmount = (medicine, patientMembershipDet) => {
    if (!patientMembershipDet) return 0;
    const currentPrice = Number(medicine?.mrp) || 0;
    const discountPercent =
      Number(patientMembershipDet?.discountPercentage) || 0;
    const discountAmount = Math.floor(currentPrice * (discountPercent / 100));
    return discountAmount;
  };

  const fetchMembershipDetails = async () => {
    const payload = {
      // patientId: patientData?.patientId,
      membershipCard: patientData?.membershipCard,
      serviceCategory: medicineObj?.drugCategory || "RX",
    };

    try {
      const response = await PatientService.patientMembershipDet(payload);
      setPatientMembershipDet(response?.data?.data?.[0] || null);
    } catch (e) {
      console.error(e);
    }
  };

  const handleAdrrsFormClose = () => {
    setIsAddressModalOpen(false);
    setFormData({
      firstName: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      mobile: "",
      pinCode: "",
      state: "",
    });
  };

  const fetchPatientAddress = async () => {
    let payload = {
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
    };
    try {
      let result = await LocationService.getPatientAddress(payload);
      if (result.data.length > 0) {
        setAddress(result.data?.[0] || null);
      } else {
        setAddressModButton(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCartDetails = () => {
    try {
      const payload = { patientId: patientData.patientId };
      dispatch(getCartDetails(payload));
    } catch (error) {
      console.error("Error fetching cart details:", error);
    }
  };

  const scrollUp = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ top: -100, behavior: "smooth" });
    }
  };

  const scrollDown = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ top: 100, behavior: "smooth" });
    }
  };

  const tabContent = {
    Description:
      "This is the description of the medicine. It includes details about what the medicine is used for.",
    "How to Use":
      "Use this medicine exactly as prescribed by your doctor. Do not exceed the recommended dose.",
    "Safety Information":
      "With 500mg of pure Ashwagandha per capsule, this supplement ensures concentrated and effective dose. The capsule format facilitates seamless integration of Ashwagandha into your daily health routine, supporting holistic growth and well-being.",
    "Other Information":
      "Store in a cool, dry place. Check the expiry date before use.",
  };

  const tabs = [
    "Description",
    "How to Use",
    "Safety Information",
    "Other Information",
  ];

  const handleAddToCart = async ({ itemObj, type }) => {
    if (!patientData && patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (!itemObj) return;
   
    setLoader(true);
    const now = getCurrentTime();
    const existingCartId = cartData?.cartId;
    const cartHdrs = [...(cartData?.cartOrderHdr || [])];
    const itemCode = itemObj.code;
    const itemName = itemObj.medicineName;
    const itemCategory = itemObj.drugCategory;
    const vendorId = itemObj.pharmacyId;
    const price = parseFloat(itemObj.mrp || 0);

    const existingHdr = cartHdrs.find((hdr) => hdr.orderType === type);

    let payload;

    if (!existingCartId) {
      // No cart – create new
      const dtlItem = createCartOrderDtlItem({
        item: {
          code: itemCode,
          name: itemName,
          drugCategory: itemCategory,
          price,
          vendorId,
        },
        type,
        patientId: patientData.patientId,
        user: patientData,
      });

      payload = {
        cartOrderHdr: [
          createCartOrderHdrItem({
            Acc_branch: {
              acc_Id: itemObj.pharmacyId,
              bran_Id: itemObj.branchId,
            },
            dtlItem,
            account: address || null,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        ],
        cartType: 1,
        patientId: patientData.patientId,
        paymentType: "",
        status: 1,
      };

      let grandTotalAmount = payload?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...payload,
        totalAmount: grandTotalAmount,
      };
    } else {
      // Update existing cart
      const newHdrs = cartHdrs.map((hdr) => {
        if (hdr.orderType !== type) return hdr;

        const existingItem = hdr.cartOrderDtl.find(
          (i) => i.orderCode === itemCode,
        );
        let updatedDtl = [...hdr.cartOrderDtl];
        if (existingItem) {
          updatedDtl = updatedDtl.map((i) =>
            i.orderCode === itemCode
              ? {
                  ...i,
                  quantity: i.quantity + 1,
                  amount: (i.quantity + 1) * i.unitPrice,
                  paidAmount: (i.quantity + 1) * i.unitPrice,
                  modifiedDate: now,
                  orderState: "U",
                }
              : i,
          );
        } else {
          const newDtlItem = createCartOrderDtlItem({
            item: {
              code: itemCode,
              name: itemName,
              drugCategory: itemCategory,
              price,
              vendorId,
            },
            type,
            patientId: patientData.patientId,
            user: patientData,
            cartId: existingCartId,
          });
          updatedDtl.push(newDtlItem);
        }

        const totalAmt = updatedDtl.reduce(
          (sum, i) => sum + Number(i.amount),
          0,
        );
        const totalPaid = updatedDtl.reduce(
          (sum, i) => sum + Number(i.paidAmount),
          0,
        );
        return {
          ...hdr,
          cartOrderDtl: updatedDtl,
          amount: parseFloat(totalAmt),
          paidAmount: parseFloat(totalPaid),
          modifiedDate: now,
        };
      });

      // If this type doesn't exist yet, add it
      if (!existingHdr) {
        const dtlItem = createCartOrderDtlItem({
          item: {
            code: itemCode,
            name: itemName,
            drugCategory: itemCategory,
            price,
            vendorId,
          },
          type,
          patientId: patientData.patientId,
          user: patientData,
          cartId: existingCartId,
        });

        newHdrs.push(
          createCartOrderHdrItem({
            Acc_branch: {
              acc_Id: itemObj.pharmacyId,
              bran_Id: itemObj.branchId,
            },
            dtlItem,
            account: address || null,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        );
      }

      let grandTotalAmount = newHdrs?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...cartData,
        cartId: existingCartId,
        cartOrderHdr: newHdrs,
        modifiedDate: now,
        totalAmount: grandTotalAmount,
      };
    }
    try {
      const updatedCart = await dispatch(AddtoCart(payload));
      // dispatch(updateCartState(updatedCart.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
      message.success("Medicine added to cart successfully.");
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
    // history.push(APP_ROUTES.MYCART);
  };

  const handleIncreaseQty = async () => {
    if (!medCartData || !cartData) return;

    const updatedCart = { ...cartData };
    const hdrIndex = updatedCart.cartOrderHdr.findIndex(
      (order) => order.orderType === "DRUG",
    );

    if (hdrIndex === -1) return;

    const cartMedObj = updatedCart.cartOrderHdr[hdrIndex];
    const dtlIndex = cartMedObj.cartOrderDtl.findIndex(
      (item) => item.orderCode === medCartData.orderCode,
    );

    if (dtlIndex === -1) return;

    setLoader(true);
    const item = cartMedObj.cartOrderDtl[dtlIndex];
    item.quantity += 1;
    item.amount = item.quantity * item.unitPrice;
    item.paidAmount = item.amount;
    item.orderState = "U";
    item.modifiedDate = getCurrentTime();

    // Recalculate header totals
    cartMedObj.amount = cartMedObj.cartOrderDtl.reduce(
      (sum, i) => sum + Number(i.amount),
      0,
    );
    cartMedObj.paidAmount = cartMedObj.cartOrderDtl.reduce(
      (sum, i) => sum + Number(i.paidAmount),
      0,
    );
    cartMedObj.modifiedDate = getCurrentTime();

    updatedCart.cartOrderHdr[hdrIndex] = cartMedObj;
    updatedCart.modifiedDate = getCurrentTime();

    try {
      const updatedCartData = await dispatch(AddtoCart(updatedCart));
      // dispatch(updateCartState(updatedCartData.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
    // dispatch(getCartDetails({ patientId: patientData.patientId }));
  };

  const handleDecreaseQty = async () => {
    if (!medCartData || !cartData) return;

    const updatedCart = { ...cartData };
    const hdrIndex = updatedCart.cartOrderHdr.findIndex(
      (order) => order.orderType === "DRUG",
    );

    if (hdrIndex === -1) return;

    const cartMedObj = updatedCart.cartOrderHdr[hdrIndex];
    const dtlIndex = cartMedObj.cartOrderDtl.findIndex(
      (item) => item.orderCode === medCartData.orderCode,
    );

    if (dtlIndex === -1) return;

    const item = cartMedObj.cartOrderDtl[dtlIndex];

    const now = getCurrentTime();
    setLoader(true);

    if (item.quantity > 1) {
      // Just decrease quantity
      item.quantity -= 1;
      item.amount = item.quantity * item.unitPrice;
      item.paidAmount = item.amount;
      item.orderState = "U";
      item.modifiedDate = now;
    } else {
      // Treat as a remove
      item.status = 0; // Soft delete
      item.orderState = "U";
      item.modifiedDate = now;
    }

    // Recalculate hdr totals based on active items
    const activeItems = cartMedObj.cartOrderDtl.filter((i) => i.status !== 0);
    cartMedObj.cartOrderDtl = cartMedObj.cartOrderDtl; // keep full list with soft deleted
    cartMedObj.amount = activeItems.reduce(
      (sum, i) => sum + Number(i.amount),
      0,
    );
    cartMedObj.paidAmount = activeItems.reduce(
      (sum, i) => sum + Number(i.paidAmount),
      0,
    );
    cartMedObj.modifiedDate = now;

    updatedCart.cartOrderHdr[hdrIndex] = cartMedObj;
    updatedCart.modifiedDate = now;

    try {
      const updatedCartData = await dispatch(AddtoCart(updatedCart));
      // dispatch(updateCartState(updatedCartData.data));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      setLoader(false);
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const handleNewAddress = () => {
    setIsAddressModalOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddressSave = async (e) => {
    e.preventDefault();
    const isFormEmpty = Object.values(formData).every(
      (value) => value.trim() === "",
    );

    if (isFormEmpty) {
      message.error("Please enter values in the form");
      return;
    }

    let payload = {
      account_Id: patientData.account_Id,
      clinic_Id: patientData.clinic_Id,
      createdBy: patientData.patientId,
      modifiedBy: patientData.patientId,
      patientId: patientData.patientId,
      defaultAddressYN: "Y",
      status: 1,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      ...formData,
    };
    try {
      await LocationService.savePatientAddress(payload);
      setAddressModButton(false);
      setIsAddressModalOpen(false);
      fetchPatientAddress();
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  return (
    <Layout>
      <div className="p-5">
        <div className="w-full flex justify-between">
          <div className="flex gap-2 items-center">
            <h3 className="text-[#189FAA] font-sans font-semibold text-sm">
              Book Medicine
            </h3>
            <p>/</p>
            <h3 className="font-sans font-semibold text-sm text-[#189FAA]">
              Medicines
            </h3>
            <p>/</p>
            <h3 className="font-sans font-semibold text-sm text-[#232323]">
              {medicineObj?.medicineName}
            </h3>
          </div>
        </div>
        <div className="border shadow-md rounded-md mt-7 w-[98%] m-auto ">
          <div className="flex gap-10 p-6 mx-10">
            <div className="flex flex-col items-center gap-2">
              <button
                onClick={scrollUp}
                className="w-8 h-8 flex items-center justify-center rounded-full border bg-[#E2F3F4] border-gray-300"
              >
                <FiChevronUp className="text-[#189FAA]" />
              </button>

              <div
                ref={scrollRef}
                className="flex flex-col gap-3 overflow-y-auto max-h-60 scrollHide"
              >
                {medicineObj?.imageUrlList?.map((img, index) => (
                  <img
                    key={index}
                    src={img}
                    alt={`Medicine ${index + 1}`}
                    onClick={() => setSelectedImage(img)}
                    className={`w-14 h-14 object-cover rounded cursor-pointer border ${
                      selectedImage === img
                        ? "border-teal-500"
                        : "border-gray-300"
                    }`}
                  />
                ))}
              </div>

              <button
                onClick={scrollDown}
                className="w-8 h-8 flex items-center justify-center rounded-full border bg-[#E2F3F4] border-gray-300"
              >
                <FiChevronDown className="text-[#189FAA]" />
              </button>
            </div>

            <div className="w-[450px]">
              <img
                src={selectedImage}
                alt="Medicine"
                className="w-full h-[310px] object-contain rounded border border-gray-300 shadow-md"
              />
            </div>
            <div className="w-[450px] p-3 border rounded-md shadow-md">
              <h2 className="text-sm font-sans font-semibold text-[#000000] mb-2">
                {medicineObj?.medicineName}
              </h2>
              <p className="text-xs font-sans font-medium text-[#738483] mb-3">
                {medicineObj.packaging}
              </p>
              <hr />
              <div className="flex items-center gap-2 mt-3">
                <p className="text-lg font-sans font-semibold text-[#333333]">
                  {`${CURRENCYCODE} `}
                  {medicineObj.mrp}
                </p>

                <p className="text-xs font-light font-sans text-red-500">
                  (Only 1 left, Order now)
                </p>
              </div>
              <p className="text-gray-400 text-xs font-sans font-medium">
                (All prices included VAT)
              </p>

              {patientMembershipDet && (
                <div className="flex items-center gap-2 my-2">
                  {/* <div
                                    className={`w-max p-[1.5px] rounded-md bg-gradient-to-r ${patientMembershipDet?.membershipCode === "SINGLE"
                                        ? "from-[#81CAF4] to-[#58B4E9]"
                                        : patientMembershipDet?.membershipCode === "TWIN"
                                            ? "from-[#5DEB6D] to-[#34CF47]"
                                            : patientMembershipDet?.membershipCode === "FAMILY" ? "from-[#35D9D4] to-[#1DBBB6]" : ''
                                        }`}
                                >
                                    <p className="p-2 rounded-md flex flex-col justify-center bg-white">
                                        <span className="font-medium text-sm">
                                            {patientMembershipDet?.membershipCode === "SINGLE"
                                                ? "Single member"
                                                : patientMembershipDet?.membershipCode === "TWIN"
                                                    ? "Twin members"
                                                    : patientMembershipDet?.membershipCode === "FAMILY" ? "Family" : ''}
                                        </span>
                                        <span className="text-xs font-normal text-gray-500">Membership</span>
                                    </p>
                                </div> */}

                  <div className="flex items-center gap-1">
                    <span className="text-lg font-sans font-semibold text-[#333333]">
                      <span className="text-sm font-normal text-gray-400 mr-0.5">
                        {`${CURRENCYCODE} `}
                      </span>
                      {calculateDiscountedPrice(
                        medicineObj,
                        patientMembershipDet,
                      )}
                    </span>
                    <span className="line-through text-[#738483] font-opensans text-base">
                      {medicineObj.mrp}
                    </span>
                    <span className="text-[#117F0D]">
                      ({`Save ${CURRENCYCODE} `}
                      {calculateDiscountAmount(
                        medicineObj,
                        patientMembershipDet,
                      ) || "-"}
                      )
                    </span>
                  </div>
                </div>
              )}

              <ul className="bg-[#F4FEFF] text-xs font-sans font-medium text-[#333333] p-3 rounded mb-4 list-disc list-inside mt-5">
                <li>Reduces stress and anxiety</li>
                <li>Enhances brain function</li>
                <li>Boosts immunity</li>
                <li>Improves sleep quality</li>
              </ul>

              <div className="flex items-center gap-3">
                {!isMedicineThereInCart ? (
                  <>
                    {/* <select className="border rounded px-4 py-2 text-sm">
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </select> */}
                    <button
                      onClick={() =>
                        handleAddToCart({
                          itemObj: medicineObj,
                          type: "DRUG",
                        })
                      }
                      disabled={loader}
                      className="bg-[#189FAA] w-full font-sans font-semibold text-white px-6 py-2 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Add to cart
                    </button>
                  </>
                ) : (
                  <div className="flex justify-center items-center w-full">
                    <button
                      className="bg-[#189FAA] w-12 font-sans font-semibold text-white px-6 py-2 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                      onClick={handleDecreaseQty}
                      disabled={loader}
                    >
                      <FaMinus className="w-3 h-3" />
                    </button>

                    <input
                      className="mx-2 border rounded-lg text-center w-12 h-8"
                      type="text"
                      value={medCartData?.quantity || 0}
                      readOnly
                    />

                    <button
                      className="bg-[#189FAA] w-12 font-sans font-semibold text-white px-6 py-2 rounded text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                      onClick={handleIncreaseQty}
                      disabled={loader}
                    >
                      <FaPlus className="w-3 h-3" />
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col  justify-evenly rounded-md items-center p-3 border text-xs text-gray-600">
              <div className="flex gap-3 items-center mb-4">
                <img src={Trust} alt="" />
                <p className="text-center">Trusted Shipping</p>
              </div>

              <div className="flex gap-3 items-center mb-4">
                <img src={Secure} alt="" />
                <p className="text-center">Secure payment</p>
              </div>

              <div className="flex gap-3 items-center">
                <img src={Thumbs} alt="" />

                <p className="text-center">Trusted brands</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mx-auto p-4 w-full">
          <div className="flex flex-wrap mb-4 border rounded-md gap-2 sm:gap-0 w-max">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-sm mx-auto rounded-md  ${
                  activeTab === tab
                    ? "bg-teal-500 text-white border-teal-500 font-sans font-semibold"
                    : "bg-white text-[#333333] border-gray-300 font-sans font-semibold"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="p-4 border border-gray-200 rounded-md text-sm bg-[#F8FEFF] text-[#333333] font-sans font-medium">
            {tabContent[activeTab]}
          </div>
        </div>
        <div className="bg-[#FFF0F0] p-2 rounded-md mx-3">
          <p className="text-[#333333] font-sans font-semibold text-sm">
            DISCLAIMER
          </p>
          <p className="text-xs font-sans font-medium mt-3 leading-5 mx-2">
            The information provided on this website is to the best of our
            abilities to ensure it is accurate, reliable, and reviewed by a team
            of professionals. It should not be used to diagnose, prevent, or
            cure any health problem. The information presented here is not
            intended to create a doctor-patient relationship or replace a
            registered medical practitioner's advice, diagnosis, or treatment.
            The absence or provision of any information or warning regarding any
            medicine should not be assumed as an implied or explicit assurance
            of safety or efficacy. We highly recommend consulting your
            registered medical practitioner for all queries or doubts related to
            your medical condition. Do not ignore professional medical advice or
            delay seeking it based on the content encountered on our website. We
            intend to support, not replace, the doctor-patient relationship.
          </p>
        </div>

        <Modal
          title={
            <span className="text-sm font-semibold font-sans text-[#189FAA]">
              Add Address
            </span>
          }
          open={isAddressModalOpen}
          onCancel={handleAdrrsFormClose}
          footer={[]}
          destroyOnClose
        >
          <form className="space-y-4 mt-3">
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Name"
                name="firstName"
                disabled={true}
                value={formData.firstName || ""}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Mobile Number"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
              <input
                type="text"
                placeholder="Pin Code"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
              />
            </div>
            <div className="flex gap-2">
              <select
                value={formData.state}
                onChange={handleChange}
                name="state"
                className="w-full py-2 px-3 border rounded text-xs text-gray-400 font-sans  outline-none"
              >
                <option value="" disabled>
                  Select State
                </option>
                {states.map((state) => (
                  <option key={state.stateId} value={state.stateId}>
                    {state.stateName}
                  </option>
                ))}
              </select>
              <select
                value={formData.country}
                onChange={handleChange}
                name="country"
                className="w-full px-3 py-2 border rounded font-sans text-gray-400  text-xs outline-none"
              >
                <option value="" disabled>
                  Select Country
                </option>
                {countries.map((country) => (
                  <option key={country.country_Id} value={country.country_Id}>
                    {country.country_Name}
                  </option>
                ))}
              </select>
            </div>
            <textarea
              placeholder="Full Address"
              rows="3"
              value={formData.address1}
              name="address1"
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded text-sm font-sans placeholder:text-xs outline-none"
            />

            <div className="flex justify-end gap-4 mt-4">
              <button
                type="button"
                onClick={handleAdrrsFormClose}
                className="px-4 py-1 border border-cyan-600 font-sans text-sm font-medium text-cyan-600 rounded"
              >
                Cancel
              </button>
              <button
                className="px-4 py-1 bg-[#189FAA] font-sans text-sm text-white font-semibold rounded"
                onClick={handleAddressSave}
              >
                Save Address
              </button>
            </div>
          </form>
        </Modal>
      </div>
    </Layout>
  );
}

export default MedicineDetails;
